document.addEventListener('DOMContentLoaded', function () {
    // 1. SELECT ALL INSTANCES
    const containers = document.querySelectorAll('.sticker-calc-instance');

    containers.forEach(container => {
        const sectionId = container.dataset.sectionId;
        const configElement = document.getElementById(`StickerCalc-Config-${sectionId}`);

        if (!configElement) return;

        try {
            const config = JSON.parse(configElement.textContent);
            initStickerCalculator(container, config);
        } catch (e) {
            console.error("Error parsing config:", e);
        }
    });
});

/**
 * INITIALIZATION FUNCTION
 * Scoped to each specific calculator container.
 */
function initStickerCalculator(container, config) {
    // --- UI SELECTORS ---
    const slider = container.querySelector('#qty-slider');
    const qtyInput = container.querySelector('#qty-input');
    const qtyWrapper = container.querySelector('#qty-bubble-wrapper');
    const fill = container.querySelector('#slider-fill');
    const dots = container.querySelectorAll('.slider-dot');
    const sizeSelect = container.querySelector('#sticker-size');
    const customContainer = container.querySelector('#custom-size-container');
    const widthInput = container.querySelector('#custom-width');
    const heightInput = container.querySelector('#custom-height');
    const priceNum = container.querySelector('#price-num');
    const statusIcon = container.querySelector('#status-icon');
    const statusText = container.querySelector('#status-text');
    const priceCard = container.querySelector('#price-card');
    const ctaBtn = container.querySelector('#lets-go');
    const productSelect = container.querySelector('#sticker-product');
    const valMsg = container.querySelector('#size-validation-msg');
    const originalButtonText = ctaBtn.innerHTML;

    // Access global locale window wrapper variable cleanly
    const currentLocale = typeof locale !== 'undefined' ? locale : 'de';

    // const i18n = {
    //     en: { setting: "Setting up Designer...", valid: "Size must be 3cm–29cm." },
    //     de: { setting: "Designer einrichten...", valid: "Maße müssen zwischen 3cm und 29cm liegen." }
    // }[currentLocale] || { setting: "Loading...", valid: "Check dimensions." };

    const presetCmMap = {
        '1.0': { sq: 3, rect: [5, 3] },
        '1.5': { sq: 5, rect: [7, 5] },
        '2.0': { sq: 7, rect: [9, 6] },
        '2.5': { sq: 10, rect: [12, 8] },
        '3.5': { sq: 15, rect: [18, 12] }
    };

    const invalidCombinations = {
        vinyl: {
            white_underprint: ['with']
        },

        holographic: {
            finish: ['matte']
        },

        // Future
        glitter: {
            finish: ['matte']
        }
    };

    // --- CORE LOGIC ---

    function validateDimensions() {
        let error = false;
        [widthInput, heightInput].forEach(el => {
            if (!el) return;
            const val = parseFloat(el.value.replace(',', '.'));
            if (isNaN(val) || val < 3 || val > 29) {
                el.classList.add('invalid-input');
                error = true;
            } else {
                el.classList.remove('invalid-input');
            }
        });

        if (error) {
            ctaBtn.disabled = true;
            priceNum.innerText = "0,00";
            if (valMsg) valMsg.innerText = uiTranslations.sizeValidation;
            return false;
        } else {
            ctaBtn.disabled = false;
            if (valMsg) valMsg.innerText = "";
            return true;
        }
    }

    function syncDimensions(sourceField) {
        const activeShape = container.querySelector('#shape-selector .option-item.active');
        const name = (activeShape ? activeShape.dataset.value : '').toLowerCase();

        // FIX FOR EMILIE: Independent dimensions for Rect, Oval, and Custom
        if (name.includes('custom') || name.includes('rect') || name.includes('oval')) return;

        // Forced symmetry for Circle/Square
        if (sourceField === 'width') {
            heightInput.value = widthInput.value;
        } else {
            widthInput.value = heightInput.value;
        }
    }

    /** Returns selected dimensions in mm */
    function getDimensionsMm() {
        if (sizeSelect.value === 'custom') {
            return {
                width: parseFloat(widthInput.value.replace(',', '.')) * 10,
                height: parseFloat(heightInput.value.replace(',', '.')) * 10
            };
        }

        const shape = (container.querySelector('#shape-selector .option-item.active')?.dataset.value || '').toLowerCase();
        const dims = presetCmMap[sizeSelect.value];
        const isRect = shape.includes('rect') || shape.includes('oval');

        return {
            width: (isRect ? dims.rect[0] : dims.sq) * 10,
            height: (isRect ? dims.rect[1] : dims.sq) * 10
        };
    }

    function updateCalculator(source) {
        let qty = (source === 'input') ? parseInt(qtyInput.value) : parseInt(slider.value);
        if (isNaN(qty) || qty < 1) qty = 1;

        // Sync Slider UI
        const sliderMin = 1;
        const sliderMax = 200;

        slider.min = sliderMin;
        slider.max = sliderMax;
        slider.value = Math.min(qty, sliderMax);

        const visualPercent = Math.min(
            ((qty - sliderMin) / (sliderMax - sliderMin)) * 100,
            100
        );

        if (fill) fill.style.width = visualPercent + '%';
        dots.forEach((dot, i) => {
            if (visualPercent >= (i * 50)) dot.classList.add('active');
            else dot.classList.remove('active');
        });

        if (source !== 'input') qtyInput.value = qty;
        qtyInput.style.width = ((qty.toString().length) * 10 + 20) + 'px';
        const offset = (visualPercent / 100) * (slider.offsetWidth - 18) + 9;
        if (qtyWrapper) qtyWrapper.style.left = offset + 'px';

        customContainer.style.setProperty('display', (sizeSelect.value === 'custom' ? 'block' : 'none'), 'important');

        if (!validateDimensions()) return;

        // Resolve Dimension Logic
        const dimensions = getDimensionsMm();
        const wMm = dimensions.width;
        const hMm = dimensions.height;

        const activeMat = container.querySelector('#material-selector .option-item.active');
        const matKey = activeMat ? activeMat.dataset.key : 'vinyl';
        const activeFinish = container.querySelector('input[name="finish"]:checked')?.value || 'glossy';

        // ✔ ADDED: Fetch the active white underprint selection state
        const activeUnderprint = container.querySelector('input[name="white_underprint"]:checked')?.value || 'without';

        // Calculation Call (Updated to pass white underprint metric safely if engine expects it)
        if (window.calculateStickerPrice) {
            const result = window.calculateStickerPrice(wMm, hMm, qty, matKey);
            priceNum.innerText = result.formatted;
        }

        // UI State Update
        let s = config.states[1];
        if (qty >= 200) s = config.states[200];
        else if (qty >= 100) s = config.states[100];
        else if (qty >= 50) s = config.states[50];
        else if (qty >= 10) s = config.states[10];

        if (priceCard) priceCard.className = 'price-box ' + s.class;
        if (statusText) statusText.innerText = s.txt;
        if (statusIcon) statusIcon.src = s.img;
    }

    // --- INTERACTIVE ELEMENTS ---

    // Product Dropdown Grid
    const productWrapper = container.querySelector('#product-dropdown-wrapper');
    const productTrigger = container.querySelector('#product-trigger');
    const gridOptions = container.querySelectorAll('.grid-option');

    if (productTrigger) {
        productTrigger.addEventListener('click', (e) => {
            e.stopPropagation();
            productWrapper.classList.toggle('open');
        });
    }

    gridOptions.forEach(opt => {
        opt.addEventListener('click', function () {
            const key = this.dataset.key;
            container.querySelector('#trigger-text').innerText = this.querySelector('.option-label').innerText;
            gridOptions.forEach(o => o.classList.remove('selected'));
            this.classList.add('selected');
            productWrapper.classList.remove('open');
            productSelect.value = key;
            updateCalculator();
        });
    });

    // Listeners
    qtyInput.addEventListener('input', function () {
        this.value = this.value.replace(/[^0-9]/g, '');
        updateCalculator('input');
    });

    widthInput.addEventListener('input', () => { syncDimensions('width'); updateCalculator(); });
    heightInput.addEventListener('input', () => { syncDimensions('height'); updateCalculator(); });
    slider.addEventListener('input', () => updateCalculator('slider'));
    slider.addEventListener('change', () => {
        qtyInput.focus();

        const length = qtyInput.value.length;
        qtyInput.setSelectionRange(length, length);
    });

    container.querySelectorAll('#shape-selector .option-item').forEach(item => {
        item.addEventListener('click', function () {
            container.querySelectorAll('#shape-selector .option-item').forEach(el => el.classList.remove('active'));
            this.classList.add('active');
            syncDimensions('width');
            updateCalculator();
        });
    });

    container.querySelectorAll('#material-selector .option-item').forEach(item => {
        item.addEventListener('click', function () {
            container.querySelectorAll('#material-selector .option-item').forEach(el => el.classList.remove('active'));
            this.classList.add('active');
            updateOptionAvailability();
            updateCalculator();
        });
    });

    container.querySelectorAll('input[name="finish"]').forEach(radio => {
        radio.addEventListener('change', () => updateCalculator());
    });

    // ✔ ADDED: Bind structural selection listeners to recalculate price dynamically on click change
    container.querySelectorAll('input[name="white_underprint"]').forEach(radio => {
        radio.addEventListener('change', () => updateCalculator());
    });

    // Initiate Antigro
    ctaBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (!validateDimensions()) return;

        ctaBtn.innerText = uiTranslations.settingDesigner;
        ctaBtn.disabled = true;

        const activeShape = container.querySelector('#shape-selector .option-item.active');
        const activeMat = container.querySelector('#material-selector .option-item.active');
        const activeFinish = container.querySelector('input[name="finish"]:checked');

        // Get runtime selection state parameters for checkout mapping
        const activeUnderprint = container.querySelector('input[name="white_underprint"]:checked');

        const dimensions = getDimensionsMm();

        const payload = {
            customer_id: config.customer.id,
            customer_email: config.customer.email,
            customer_name: config.customer.name,
            product_id: config.product.id,
            product_name: config.product.title,
            product_handle: config.product.handle,
            product_code: productSelect.value || "kiss_cut",
            quantity: parseInt(qtyInput.value),
            width_mm: dimensions.width,
            height_mm: dimensions.height,
            shape: activeShape.dataset.value,
            material: activeMat ? activeMat.dataset.key : 'vinyl',
            finishing: activeFinish ? activeFinish.value : '',
            underprint: activeUnderprint ? activeUnderprint.value : 'no', // ✔ Added payload delivery parameter mapping
            locale: currentLocale
        };
        console.log(payload);

        const validation = validateCombination(
            payload.material,
            payload.finishing,
            payload.underprint,
            invalidCombinations
        );

        if (!validation.valid) {

            ctaBtn.innerText = originalButtonText;
            ctaBtn.disabled = false;

            smModal.open({
                title: modalTranslations.invalidCombinationTitle,
                message: modalTranslations[validation.messageKey],
                confirmText: modalTranslations.btnOk,
                type: "primary"
            });

            return;
        }

        fetch(backendUrl + '/antigro/initiate', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) window.location.href = data.designer_url;
                else {
                    ctaBtn.innerText = originalButtonText;
                    ctaBtn.disabled = false;
                    smModal.open({
                        title: modalTranslations.errorTitle,
                        message: data.message || modalTranslations.genericError,
                        confirmText: modalTranslations.btnOk,
                        type: "primary"
                    });
                }
            });
    });

    // Handle Dropdowns
    setupDropdownInstance(container, 'size-dropdown-wrapper', 'sticker-size', updateCalculator);

    // Outside Click Close
    document.addEventListener('click', () => {
        if (productWrapper) productWrapper.classList.remove('open');
        const sizeWrap = container.querySelector('#size-dropdown-wrapper');
        if (sizeWrap) sizeWrap.classList.remove('open');
    });

    function updateOptionAvailability() {
        const activeMaterial =
            container.querySelector('#material-selector .option-item.active')?.dataset.key;

        // Reset all disabled options
        container.querySelectorAll('input[name="finish"], input[name="white_underprint"]')
            .forEach(input => {
                input.disabled = false;
                input.closest('label').classList.remove('disabled-option');
            });

        const rules = invalidCombinations[activeMaterial];

        if (!rules) return;

        Object.entries(rules).forEach(([groupName, values]) => {

            values.forEach(value => {

                const option = container.querySelector(
                    `input[name="${groupName}"][value="${value}"]`
                );

                if (!option) return;

                option.disabled = true;
                option.closest('label').classList.add('disabled-option');

                // Automatically switch if disabled option is currently selected
                if (option.checked) {

                    const firstAvailable = container.querySelector(
                        `input[name="${groupName}"]:not([disabled])`
                    );

                    if (firstAvailable) {
                        firstAvailable.checked = true;
                    }
                }
            });

        });
    }

    updateOptionAvailability();
    updateCalculator();
}

/**
 * UTILITY: Dropdown logic scoped to instance
 */
function setupDropdownInstance(container, wrapperId, selectId, callback) {
    const wrapper = container.querySelector(`#${wrapperId}`);
    if (!wrapper) return;
    const trigger = wrapper.querySelector('.custom-select-trigger');
    const options = wrapper.querySelectorAll('.custom-option');
    const select = container.querySelector(`#${selectId}`);

    trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        wrapper.classList.toggle('open');
    });
    options.forEach(opt => {
        opt.addEventListener('click', () => {
            trigger.innerText = opt.innerText;
            options.forEach(o => o.classList.remove('selected'));
            opt.classList.add('selected');
            wrapper.classList.remove('open');
            select.value = opt.dataset.value;
            callback();
        });
    });
}